/** Absolute minimum hourly rate any shift may be posted at, in USD. */
export const ABSOLUTE_RATE_FLOOR = 18;

/** Default share of the recommended (average) rate used as the floor, by profession code. */
export const DEFAULT_RATE_FLOOR_PERCENTAGES: Record<string, number> = {
  RDH: 0.65,
  DA: 0.7,
  EFDA: 0.7,
  FD: 0.7,
  DN: 0.65,
};

/**
 * Lowest hourly rate selectable for a profession: the larger of the absolute
 * floor and a share of the recommended rate, rounded down to the dollar.
 * Falls back to the absolute floor when the share or average rate is unusable.
 */
export const calculateRateFloor = (averageRate: number, percentage?: number): number => {
  if (!percentage || averageRate <= 0) {
    return ABSOLUTE_RATE_FLOOR;
  }

  return Math.max(ABSOLUTE_RATE_FLOOR, Math.floor(averageRate * percentage));
};
